import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from '@environment';
import { Observable, Subject, takeUntil } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AiPromptService {
  private cancelSubject = new Subject<void>();

  constructor(private api: ApiService) {}

  public getAiPrompt(prompt: {
    text: string;
    translate?: string;
    improvement?: string;
    aigenerated?: { goal: string; audience: string };
    language?: string;
  }): Observable<any> {
    return this.api
      .post(environment.backendBaseUrl, `/api/v1/ai_prompts`, prompt)
      .pipe(takeUntil(this.cancelSubject));
  }

  public cancel(): void {
    this.cancelSubject.next();
    this.cancelSubject = new Subject<void>();
  }
}
